var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowDown24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94 0.53125L4 3.58458L7.06 0.53125L8 1.47125L4 5.47125L0 1.47125L0.94 0.53125Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboardArrowDown24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyboard_arrow_down_24px.24c111b28b5d4d766596e682167baa2c.svg";